module.exports = __webpack_public_path__ + "img/icon-demand.87ce1f86.svg";